import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
} from 'chart.js';

import { Bar, Line } from 'react-chartjs-2';
import { top20PartWise } from '../../../helpers/getDashBoardData';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
);

interface IProps {
  apiData: any;
  top20?: any;
  // year: number;
}
const getNewApiData = (apiData: any) => {
  const defectsNames = [
    'BLANK SHORT',
    'CRACK',
    'TRIM',
    'BENDING SHIFT',
    'DAMAGE',
    'DOUBLE STAMPING',
    'DIMPLE NG',
    'DIMPLE DIA.',
    'DENT',
    'HOLE DIA. NG',
    'PUNCH OUT',
    'HOLE SHIFT',
    'HEAVY SCRATCH',
    'HEAVY BURR',
    'WELDING FAULT',
    'operation miss',
    'DIMPLE MISS',
    'GAUGE NG',
    'RUSTY',
    'DEMAGE',
    'SLUG JAM',
  ];

  const output = [];
  let totalSum = 0;
  for (let i = 0; i < defectsNames.length; i++) {
    let sum = 0;
    for (const partName in apiData) {
      sum += apiData[partName][i];
    }
    totalSum += sum;
    if (sum > 0) {
      output.push({
        defectName: defectsNames[i],
        count: sum,
        totalSum: totalSum,
      });
    }
  }

  return output;
};
const getCumulativePercenatge = (apiData: any) => {
  const output = getNewApiData(apiData);
  const totalSum = output[output.length - 1]?.totalSum;
  const result = output.map((item: any) =>
    ((item.totalSum * 100) / totalSum).toFixed(2)
  );
  return result;
};
const ParetoChart = ({ apiData, top20 }: IProps) => {
  const data = getNewApiData(apiData).sort((a, b) => b.count - a.count);
  const labels = data.map((item: { defectName: any }) => item.defectName);
  const chartData: any = {
    labels: top20
      ? top20PartWise(apiData).map((item: { PartName: any }) => item.PartName)
      : labels,
    datasets: [
      {
        label: top20 ? 'Parts Qty.' : 'Defects Qty.',
        data: top20
          ? top20PartWise(apiData).map(
              (item: { rejectionCount: any }) => item.rejectionCount
            )
          : data.map((item: { count: any }) => item.count),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Cumulative %',
        data: top20
          ? top20PartWise(apiData).map(
              (item: { cummPercenatge: any }) => item.cummPercenatge
            )
          : getCumulativePercenatge(apiData),
        type: 'line',
        borderColor: '#a61e4d',
        fill: false,
        yAxisID: 'y-axis-percentage',
      },
    ],
  };

  const chartOptions: any = {
    plugins: {
      maintainAspectRatio: false,
      title: {
        display: true,
        // text: top20
        //   ? 'Pareto Chart - Top 20 Parts'
        //   : 'Defect wise pareto analysis',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: top20 ? 'Parts' : 'Defects',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: top20 ? 'Parts Qty.' : 'Defects Qty.',
        },
      },
      'y-axis-percentage': {
        beginAtZero: true,
        position: 'right',
        title: {
          display: true,
          text: 'Cumulative %',
        },
        grid: {
          display: false,
        },
        max: 100,
      },
    },
  };

  return (
    <div>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default ParetoChart;
